import { ProductAttributes } from "../../hooks/useStandardProducts";

type ScalarArray = Array<string | number | boolean | undefined>;

export const ATTRIBUTES = {
  COVER_TYPE: "coverType",
  COVER_FINISH: "coverFinish",
  TEXT_STOCK: "textStock",
  STOCK_STYLE: "stockStyle",
  DIMENSIONS: "dimensions",
  ORIENTATION: "orientation",
  BIND_TYPE: "bindType",
  TEXT_PRINT_MODE: "textPrintMode",
  PRODUCT_CLASS: "productClass",
} as const;

export function isSoftcover(attributes: ProductAttributes) {
  const softcoverTypes: ScalarArray = ["SCIW"];
  return softcoverTypes.indexOf(attributes[ATTRIBUTES.COVER_TYPE]) >= 0;
}

export function isHardcover(attributes: ProductAttributes) {
  const hardcoverTypes: ScalarArray = ["HCIW"];
  return hardcoverTypes.indexOf(attributes[ATTRIBUTES.COVER_TYPE]) >= 0;
}

// Order disabled combinations after enabled ones, preserving relative order otherwise.
export function sortDisabledLast(
  combinations: ProductAttributes[],
  isDisabled: (combination: ProductAttributes) => boolean
): ProductAttributes[] {
  return [...combinations].sort((a, b) => {
    const aDisabled = isDisabled(a);
    const bDisabled = isDisabled(b);
    if (aDisabled === bDisabled) return 0;
    return aDisabled ? 1 : -1;
  });
}
